(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsNewManualController', CmsNewManualController);

  /* ngInject */
  function CmsNewManualController($state, Flash, cmsBucketService, cmsManualService, formErrorsService, publishedStatuses, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.bucketTitle = null;
    vm.buckets = [];
    vm.createBucket = createBucket;
    vm.createManual = createManual;
    vm.manual = {};
    vm.manualForm = {};
    vm.publishedStatuses = publishedStatuses;

    activate();

    function activate() {
      getBuckets();
    }

    function createBucket() {
      let bucket = {
        title: vm.bucketTitle,
        resource_type: 'manual'
      };

      cmsBucketService(sessionService.getAuthToken()).save(bucket, response => {
        vm.buckets.push(response);
        vm.manual.bucket_id = response.id;
        vm.bucketTitle = null;
        Flash.create('success', 'Bucket successfully created.');
      }, error => {
        Flash.create('danger', 'An error occurred with the submission. Please correct the errors below and resubmit.');
        vm.setFormErrors(vm.helpfulResourceForm, error);
      });
    }

    function createManual() {
      cmsManualService(sessionService.getAuthToken()).save(vm.manual, _createManualSuccess, _createManualFailure);
    }

    function getBuckets() {
      cmsBucketService(sessionService.getAuthToken()).query({ resource_type: 'manual' }, response => vm.buckets = response);
    }

    function _createManualSuccess(response) {
      Flash.create('success', 'Manual was successfully created.');
      $state.go('application.compliance_services.cms_edit_manual', {id: response.id});
    }

    function _createManualFailure(response) {
      Flash.create('danger', 'An error occurred with the submission. Please correct the errors below and resubmit.');
      vm.setFormErrors(vm.manualForm, response);
    }
  }
})();
